import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {
    Elink, CreateNewRoomUrl, FetchRoomCategoriesUrl
} from "../CommonComponents/Routes";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Animation} from "./Animation";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

const CustomRoom = () => { // this component is used to create new custom room
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    const [RoomName, SetRoomName] = useState('');
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;
    useEffect(()=>{
        if(RecordController.Click){
            Animation('custom_room', RecordController.Click)
        }
    },[])
    const Cancel = () => { // move back to add inventory
        RecordController.SetClick('downward');
        AnimationPrevious("downward-go", "custom_room", "ADD_NEWROOM", PageView);
    }

    const Validate = (device_type) => { // validate field for all views
        let element = document.getElementsByClassName("room-name")
        for ( let i = 0; i < element.length; i++) {
            if(element[i]["id"] === device_type) {
                if (element[i]["value"] === "") {
                    element[i].setAttribute('style', 'border: 2px solid red');
                    return false
                } else {
                    return true
                }
            }
        }
    }

    const CreateNewRoom = (device_type)=>{ // this component is used to create new room
        if(Validate(device_type)) {
            axios({
                method: 'post',
                url: CreateNewRoomUrl,
                params: {estimate_key: Elink, name: RoomName}
            }).then((response) => {
                RecordController.setRoom(response.data);
                RecordController.SetClick('next');
                AnimationPrevious("next-go", "custom_room", "ADD_INVENTORIES", PageView);
            })
        }
    }

    const AddNewRoomName = (device_type) => {
        return (
            <div className="container">
                <div className="row new-room-row">
                    <div className="col-md-2 col-lg-3 col-xl-3">
                        <div className="">
                            <button className="btn-st-back" style={{borderRadius: "8px", backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}} type="submit" onClick={()=> Cancel()}>Cancel</button>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6 ">
                        <div className="header-tx text-center">
                            <div className="cross"  onClick={()=> Cancel()}>
                                <i className="fa fa-times" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), fontSize: "25px"}}></i>
                            </div>
                            <h3 style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>Custom Room</h3>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-3 col-xl-3">
                    </div>
                </div>
                <div className="flex-row justify-content-center custom_room_div" style={{marginTop: "7rem", maxWidth: "100%"}}>
                    <div className="col-lg-6 col-md-6 col-sm-12" style={{margin: "0 auto"}}>
                        <label htmlFor="room-name" className="col-form-label required-field"><b>Room Name</b></label>
                        <input type="text" className={"form-control room-name"} id={device_type} onChange={(e)=>SetRoomName(e.target.value)} value={RoomName} />
                    </div>
                    <br/>
                    <div className={'text-center'}>
                    <button className="btn btn-active" type={"submit"} style={{width: "20%", zIndex: "-1", backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}
                            onClick={()=>CreateNewRoom(device_type)}>NEXT</button>
                    </div>
                </div>

            </div>
        )
    }

    return (
        <>
            <section className="item-section-2 desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}>
                <div className={"custom_room"} style={{width: "100vw"}}>
                    {AddNewRoomName("desktop-vw")}
                </div>
            </section>
            <section className="mobile-vw">
                <div className="container-mv">
                    <svg viewBox="0 0 500 500"
                         preserveAspectRatio="xMinYMin meet"
                         style={{zIndex: -1}} id="svg-mv">
                        <path d="M0, 170 C360, 30, 630,
                510 595,-400 L900, 00 L0, 0 Z"
                              style={{stroke: "none",fill: CustomerInvReq.BackgroundColor}}>
                        </path>
                    </svg>

                </div>
                <div className={"custom_room"} style={{width: "100vw"}}>
                    {AddNewRoomName("mobile-vw")}
                </div>
            </section>
        </>
    )
}
export default CustomRoom;